import type {
    CloverRefundRequestDetails,
    CloverRefundResponseDetails,
} from './clover-refund.types';
import type { CloverVoidRequestDetails, CloverVoidResponseDetails } from './clover-void.types';

export const CloverPaymentRequestFollowUpOperation = {
    VOID: 'void',
    REFUND: 'refund',
} as const;

export type CloverPaymentRequestFollowUpOperation =
    (typeof CloverPaymentRequestFollowUpOperation)[keyof typeof CloverPaymentRequestFollowUpOperation];

export interface CloverPaymentRequestFollowUpVoidRequestDetails {
    readonly operation: typeof CloverPaymentRequestFollowUpOperation.VOID;
    readonly transactions: readonly CloverVoidRequestDetails[];
}

export interface CloverPaymentRequestFollowUpRefundRequestDetails {
    readonly operation: typeof CloverPaymentRequestFollowUpOperation.REFUND;
    readonly transactions: readonly CloverRefundRequestDetails[];
}

export type CloverPaymentRequestFollowUpRequestDetails =
    | CloverPaymentRequestFollowUpVoidRequestDetails
    | CloverPaymentRequestFollowUpRefundRequestDetails;

export interface CloverPaymentRequestFollowUpVoidResponseDetails {
    readonly operation: typeof CloverPaymentRequestFollowUpOperation.VOID;
    readonly transactions: readonly CloverVoidResponseDetails[];
}

export interface CloverPaymentRequestFollowUpRefundResponseDetails {
    readonly operation: typeof CloverPaymentRequestFollowUpOperation.REFUND;
    readonly transactions: readonly CloverRefundResponseDetails[];
}

export type CloverPaymentRequestFollowUpResponseDetails =
    | CloverPaymentRequestFollowUpVoidResponseDetails
    | CloverPaymentRequestFollowUpRefundResponseDetails;

export interface CloverPaymentRequestFollowUpTransactionResult {
    readonly paymentTransactionUuid: string;
    readonly merchantTransactionId?: string;
    readonly success: boolean;
    readonly gatewayTransactionId?: string;
    readonly amount?: string;
    readonly errorMessage?: string;
}

export interface CloverPaymentRequestFollowUpResult {
    readonly success: boolean;
    readonly transactionCount: number;
    readonly successfulTransactionCount: number;
    readonly failedTransactionCount: number;
    readonly transactionResults: readonly CloverPaymentRequestFollowUpTransactionResult[];
}
